jQuery(document).ready(function() {
  setTimeout(function() {
    // Add accessibility attributes
    jQuery('.owl-buttons .owl-prev, .s-prev').attr({
      'role': 'button',
      'aria-label': 'Previous Slide',
      'tabindex': '0'
    });

    jQuery('.owl-buttons .owl-next, .s-next').attr({
      'role': 'button',
      'aria-label': 'Next Slide',
      'tabindex': '0'
    });

    // Keyboard support
    jQuery('.owl-buttons .owl-prev, .owl-buttons .owl-next').on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault(); // Prevent scroll on space
        jQuery(this).trigger('click');
      }
    });
  }, 1500); // Delay in milliseconds
  
});
jQuery(document).ready(function () {
  // ✅ Initialize only structure, not event handlers
  function initializeMenu() {
    if (jQuery('.dekstop-one .mm-submenu-toggle').length > 0) return;

    // ARIA setup, button insertions, etc.
        jQuery('.dekstop-one .mm-submenu li').removeAttr('href').removeAttr('data-href');

    // Inject submenu toggle buttons
    jQuery('.dekstop-one .mm-submenu li').each(function (index) {
      const $li = jQuery(this);
      const $a = $li.children('a');

      if (
        $li.closest('.dekstop-one .mm-last-level').length ||
        $li.find('.dekstop-one .mm-submenu-toggle').length ||
        !$a.length
      ) return;

      const btn = jQuery('<button>', {
        class: 'mm-submenu-toggle',
        type: 'button',
        'aria-expanded': 'false',
        'aria-controls': 'submenu-' + index,
        text: 'Submenu of ' + $a.text().trim()
      });

      btn.insertAfter($a);
    });
  }

  // ✅ ONE-TIME Event bindings (delegated)
  jQuery(document).on('click mousedown keydown', '.dekstop-one .buddha-menu-item > a', function (e) {
    if (
      e.type === 'click' ||
      e.type === 'mousedown' ||
      (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const $this = jQuery(this);
      const expanded = $this.attr('aria-expanded') === 'true';

      jQuery('.dekstop-one .buddha-menu-item > a').attr('aria-expanded', 'false').parent().removeClass('active-menu');

      if (!expanded) {
        $this.attr('aria-expanded', 'true').parent().addClass('active-menu');
        jQuery('.dekstop-one #menu-status-announcer').text('Submenu expanded');
      } else {
        $this.attr('aria-expanded', 'false').parent().removeClass('active-menu');
        jQuery('.dekstop-one #menu-status-announcer').text('Submenu collapsed');
      }
    }
  });

  jQuery(document).on('click mousedown keydown', '.dekstop-one .mm-submenu-toggle', function (e) {
  if (e.type === 'keydown' && e.key !== 'Enter') return;

  const $btn = jQuery(this);
  const $li = $btn.closest('li');
  const isExpanded = $btn.attr('aria-expanded') === 'true';

  // ✅ Collapse all other submenus
  jQuery('.dekstop-one .mm-submenu-toggle').not($btn).attr('aria-expanded', 'false');
  jQuery('.dekstop-one .mm-submenu li').not($li).removeClass('active-sub-menu');

  // ✅ Toggle current submenu
  $btn.attr('aria-expanded', String(!isExpanded));
  $li.toggleClass('active-sub-menu', !isExpanded);

  // ✅ Live region announcement
  jQuery('.dekstop-one #menu-status-announcer').text(!isExpanded ? 'Submenu expanded' : 'Submenu collapsed');
});


  // Escape key
  jQuery(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      jQuery('.dekstop-one .buddha-menu-item > a').attr('aria-expanded', 'false').parent().removeClass('active-menu');
      jQuery('.dekstop-one .mm-submenu-toggle').attr('aria-expanded', 'false');
      jQuery('.dekstop-one .mm-submenu li').removeClass('active-sub-menu');
      jQuery('.dekstop-one #menu-status-announcer').text('All menus collapsed');
    }
  });

  // Focus-out collapse
  jQuery(document).on('focusout', '.horizontal-mega-menu', function () {
    setTimeout(() => {
      if (!jQuery('.dekstop-one .horizontal-mega-menu').find(':focus').length) {
        jQuery('.dekstop-one .buddha-menu-item > a').attr('aria-expanded', 'false').parent().removeClass('active-menu');
        jQuery('.dekstop-one .mm-submenu-toggle').attr('aria-expanded', 'false');
        jQuery('.dekstop-one .mm-submenu li').removeClass('active-sub-menu');
      }
    }, 100);
  });

  // Initialize initially
  setTimeout(initializeMenu, 2000);

  // Reinitialize on navbar focus if not already initialized
  jQuery(document).on('focusin', '.dekstop-one .navbar', function () {
    initializeMenu();
  });
});

jQuery(document).ready(function() {
  setTimeout(function() {
    jQuery(".show-addresses .addresses > ul > li > a").attr("role", "button");
  }, 2000);
function trapFocus($modal) {
  $modal.off('keydown.trapFocus').on('keydown.trapFocus', function (e) {
    if (e.key === 'Tab') {
      const focusableSelectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';
      const $focusableItems = $modal.find(focusableSelectors).filter(':visible');

      const first = $focusableItems.first()[0];
      const last = $focusableItems.last()[0];

      if (!$focusableItems.length) return;

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    if (e.key === 'Escape') {
      jQuery('.customCloseBtn').trigger('click');
    }
  });

  // Optional: focus first item when modal becomes active
  setTimeout(() => {
    const focusableSelectors = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';
    const $focusableItems = $modal.find(focusableSelectors).filter(':visible');
    if ($focusableItems.length) {
      $focusableItems.first().focus();
    }
  }, 50);
}

jQuery('#recoverPassword').on('click', function () {
  setTimeout(function () {
    trapFocus(jQuery('#loginModal'));
  }, 100); // Slight delay to allow DOM update
});

// ✅ Case 1: On button click
jQuery('.page-tradein .nextSellContainer .scrollBtn').on('click', function () {
  setTimeout(function () {
    let $modal = jQuery('#loginModal');
    if (!$modal.is(':visible')) {
      $modal = jQuery('#termsModal');
    }
    if ($modal.is(':visible')) {
      trapFocus($modal);
    }
  }, 1000);
});

// ✅ Case 2: Automatically trap focus if #termsModal becomes visible
let wasTermsVisible = false;
setInterval(function () {
  const $termsModal = jQuery('#termsModal');
  const isVisible = $termsModal.is(':visible');

  if (isVisible && !wasTermsVisible) {
    trapFocus($termsModal);
  }

  wasTermsVisible = isVisible;
}, 300);


      jQuery('a > button.atariBtn').each(function () {
    const $atariBtn = jQuery(this);
    const $link = $atariBtn.closest('a'); // more robust than .parent()
    
    if ($link.length) {
      const btnText = $atariBtn.text().trim();

      // Only set aria-label if button has visible text
      if (btnText) {
        $link.attr('aria-label', btnText);
      }

      // Hide button from screen readers and remove from tab order
      $atariBtn.attr({
        'aria-hidden': 'true',
        'tabindex': '-1'
      });
    }
  });
    // 1. Initial setup for .cartItems
  function updateCartItemsAriaLabels() {
    jQuery('.cartItems').each(function () {
      const titleText = jQuery(this).find('.title').text().trim();

      jQuery(this).find('.btn-1').attr('aria-label', 'Add ' + titleText);
      jQuery(this).find('.btn-2').attr('aria-label', 'Reduce ' + titleText);
      jQuery(this).find('.btn-8').attr('aria-label', 'Remove ' + titleText);
    });
  }

  // 2. Setup for .searchResults inside .scroll-results
  function updateSearchResultsAriaLabels() {
    jQuery('.searchResults').each(function () {
      const titleText = jQuery(this).find('.title').text().trim();
      const $btn8 = jQuery(this).find('.btn-8');

      if ($btn8.length && titleText) {
        $btn8.attr('aria-label', 'Add ' + titleText);
        // Optional: debug
        // console.log('aria-label added to .btn-8:', 'Add ' + titleText);
      }
    });
  }

  // 3. Observe changes in .scroll-results
  const target = document.querySelector('.scroll-results');

  if (target) {
    const observer = new MutationObserver(function (mutationsList, observerInstance) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Wait 500ms to allow .searchResults and .btn-8 to render
          setTimeout(updateSearchResultsAriaLabels, 500);
          break; // You can continue observing if needed (remove this line)
        }
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  // 4. Also update .cartItems when .btn-8 is clicked
  jQuery(document).on('click', '.searchResults .btn-8', function () {
    updateCartItemsAriaLabels();
  });

  // 5. Run initially
  updateCartItemsAriaLabels();
  jQuery('#addresses_list ul').attr('aria-live','polite').attr('aria-atomic','true');
  // Unique focus trap for fancybox-buttons
function trapFocusFancyBox($container) {
  var focusableElements = 'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
    'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';

  var $focusables = $container.find(focusableElements).filter(':visible');
  if ($focusables.length === 0) return;

  var first = $focusables.first();
  var last = $focusables.last();

  $container.on('keydown.fancyTrap', function(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      if (e.shiftKey) {
        if (document.activeElement === first[0]) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last[0]) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });

  setTimeout(() => {
    first.focus();
  }, 300);
}

// Unique MutationObserver just for #fancybox-buttons
const fancyboxObserver = new MutationObserver(function(mutationsList) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const $fancybox = $('#fancybox-buttons');
      if ($fancybox.length && $fancybox.is(':visible')) {
        fancyboxObserver.disconnect(); // disconnect after first trap
        trapFocusFancyBox($fancybox);
        break;
      }
    }
  }
});

// Start watching body for #fancybox-buttons appearance
fancyboxObserver.observe(document.body, { childList: true, subtree: true });
jQuery('.featuredBrandItem > a').attr('role','tab');

    jQuery('.initialImg').attr({
  'role': 'button',
  'aria-label': 'Location',
  'tabindex': '0'
}).on('keydown', function(e) {
  if (e.key === 'Enter' || e.keyCode === 13) {
    jQuery(this).trigger('click');
  }
});
jQuery('#tradein_stepthree .mainInfo h2').attr('aria-level', '1');
jQuery('input[name="customer[email]"],#recover-email').attr('aria-label', 'email address');
jQuery('input[name="customer[password]"]').attr('aria-label', 'password');
     jQuery('.navbar-toggle').on('click', function () {
    setTimeout(function () {
      jQuery('.mobile-one .toggle-menu-btn')
        .attr('tabindex', '0')
        .on('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            jQuery(this).trigger('click');
          }
        });
    }, 1000); // Run 1 second after .navbar-toggle click
  });
  jQuery('#loginModal').attr('aria-modal','true');
  jQuery(document).on('keydown', '.searchResults .btn-8', function(e) {
  if (e.key === 'Enter' || e.keyCode === 13) {
    e.preventDefault(); // Prevent default Enter behavior
    jQuery(this).trigger('click');
  }
});


  // jQuery('.nav-tabs').each(function () {
  //   var $nav = jQuery(this);

  //   // Set role="tablist"
  //   $nav.attr('role', 'tablist');

  //   // Set initial aria-selected values
  //   updateAriaSelected($nav);

  //   // Handle tab click
  //   $nav.on('click', '.featuredBrandItem a', function () {
  //     var $item = jQuery(this).closest('.featuredBrandItem');

  //     // Optional: update active class manually (only if your system doesn't do it)
  //     $item.addClass('active').siblings('.featuredBrandItem').removeClass('active');

  //     // Update aria-selected after click
  //     updateAriaSelected($nav);
  //   });

  //  // function updateAriaSelected($nav) {
  //  //   $nav.find('.featuredBrandItem a').each(function () {
  //  //     jQuery(this).attr('aria-selected', jQuery(this).hasClass('active') ? 'true' : 'false');
  //  //   });
  //  // }
  //   function updateAriaSelected($nav) {
  //   $nav.find('.featuredBrandItem a').each(function () {
  //     var $link = jQuery(this);
  //     var isActive = $link.closest('.featuredBrandItem').hasClass('active');
  //     $link.attr('aria-selected', isActive ? 'true' : 'false');
  //   });
  // }
 /* Tab isseu start  */

// jQuery(function ($) {
//   var $nav = $('#customTab2');
//   if (!$nav.length) return;

//   // mark the list once
//   $nav.attr('role','tablist');

//   function sync() {
//     $nav.find('a.tabLink').each(function () {
//       var $a = $(this);
//       var isActive = $a.hasClass('active') || $a.parent().hasClass('active');
//       $a.attr('aria-selected', isActive ? 'true' : 'false');
//       if (isActive && $a.data('baseurl')) {
//         $('.linkToUpdate2').attr('href', $a.data('baseurl'));
//       }
//     });
//   }

//   // Bootstrap 5/4/3 event (works without jQuery plugin too)
//   document.addEventListener('shown.bs.tab', sync, false);

//   // Fallback if no BS event fired (won’t prevent default or set classes)
//   $nav.on('click', 'a.tabLink', function () { setTimeout(sync, 0); });

//   // initial
//   sync();
// });

  /* Tab isseu end */


/*  });
  
    /* home-slider-toggle.js */
(function ($) {
  $(function () {
    var $slider = $('#home-slider');
    if (!$slider.length) return;

    // IMPORTANT: init slider with autoplay OFF
    $slider.responsiveSlider({
      autoplay: false,        // <-- disable plugin autoplay
      interval: 5000,
      transitionTime: 300
    });

    var INTERVAL_MS = 5000;   // keep in sync with your slider interval
    var timer = null;
    var isPlaying = false;

    function goNext() {
      $slider.find('.s-next').trigger('click');
    }

    function play() {
      if (timer) return;
      timer = setInterval(goNext, INTERVAL_MS);
      isPlaying = true;
      $('#slider-toggle')
        .removeClass('fa-play').addClass('fa-pause')
        .find('.btn-label').text('PAUSE');
    }

    function pause() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
      isPlaying = false;
      $('#slider-toggle')
        .removeClass('fa-pause').addClass('fa-play')
        .find('.btn-label').text('PLAY');
    }

    // Start playing by default
    play();

    // Toggle button (works even if you placed HTML in the slide)
    $(document).on('click', '#slider-toggle', function (e) {
      e.preventDefault();
      isPlaying ? pause() : play();
    });

    // (Optional) uncomment to pause while hovering the slider
    // var wasPlaying = true;
    // $slider.on('mouseenter', function(){ wasPlaying = isPlaying; pause(); });
    // $slider.on('mouseleave', function(){ if (wasPlaying) play(); });
  });
})(jQuery);

});
